import apiClient from '../Utils/apiClient';

const DashboardController = {
  getOverview: async (companyId) => {
    const params = companyId ? { company_id: companyId } : {};
    const response = await apiClient.get('dashboard/overview', { params });
    return response.data;
  },

  getApiUsage: async () => {
    const response = await apiClient.get('dashboard/api-usage');
    return response.data;
  },

  getAuditLogs: async (params = {}) => {
    const response = await apiClient.get('dashboard/audit-logs', { params });
    return response.data;
  },

  getVerificationLogs: async (params = {}) => {
    const response = await apiClient.get('dashboard/verification-logs', { params });
    return response.data;
  },

  getOtpRequestsToday: async (params = {}) => {
    const response = await apiClient.get('dashboard/otp-requests-today', { params });
    return response.data;
  },

  getOpportunities: async () => {
    const response = await apiClient.get('dashboard/opportunities');
    return response.data;
  },
};

export default DashboardController;
